import type { AbstractControl, FormControlStatus } from '@angular/forms';
import { filter, startWith, take, type Observable } from 'rxjs';

/**
 * @param control Control for which validation should be awaited.
 *
 * @returns
 * An `Observable` that emits with the control status, once (async)
 * validation finished, then completes.
 */
export function awaitControlValidation(
  control: AbstractControl,
): Observable<FormControlStatus> {
  return control.statusChanges.pipe(
    startWith(control.status),
    filter((status) => status !== 'PENDING'),
    take(1),
  );
}
